(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-availability-filter"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__availabilityFilterInit) return;
    window.__availabilityFilterInit = true;

    var params = new URLSearchParams(window.location.search);
    var isOn = params.get('filter.v.availability') === '1';

    document.querySelectorAll('[data-availability-filter]').forEach(function(checkbox) {
      checkbox.checked = isOn;

      checkbox.addEventListener('change', function() {
        var url = new URL(window.location.href);

        if (checkbox.checked) {
          url.searchParams.set('filter.v.availability', '1');
        } else {
          url.searchParams.delete('filter.v.availability');
        }

        window.location.href = url.toString();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
